import { createBrowserRouter, Navigate } from "react-router-dom";
import { CreateVoucherPage } from "./core/vouchers/pages/CreateVoucherPage";
import { VouchersPage } from "./core/vouchers/pages/VouchersPage";
import { ReplenishmentsPage } from "./core/replenishments/pages/ReplenishmentsPage";
import { ApplicantsPage } from "./core/applicants/pages/ApplicantsPage";
import { WorkOrdersPage } from "./core/workOrders/pages/WorkOrdersPage";
import { LocalProductPage } from "./core/localProducts/pages/LocalProductPage";
import { ErpProductPage } from "./core/erpProduct/pages/ErpProductPage";

import ReportEPPPage from "./core/reports/pages/ReportEPPPage";
import CustomReportPage from "./core/customReports/pages/CustomReportPage";

import { AliasProductPage } from "./core/aliasProduct/pages/AliasProductPage";
import { ProductKitPage } from "./core/productKits/pages/ProductKitPage";
import ReportGeneralPage from "./core/reports/pages/ReportGeneralPage";
import MainLayout from "./ui/layouts/MainLayout";
import { ClientEntitiesPage } from "./core/clientEntities/pages/ClientEntitiesPage";
import { ActivityLabelsPage } from "./core/activityLabels/pages/ActivityLabelsPage";
import { ProductAdjustmentPage } from "./core/productAdjustment/pages/ProductAdjustmentPage";
import { NotFoundPage, RouteErrorPage } from "./ui/pages/ErrorPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    errorElement: <RouteErrorPage />,
    children: [
      {
        path: "/",
        element: <Navigate to="vouchers" />,
      },
      {
        path: "create-voucher",
        element: <CreateVoucherPage />,
      },
      {
        path: "vouchers",
        element: <VouchersPage />,
      },
      {
        path: "product-local",
        element: <LocalProductPage />,
      },
      {
        path: "product-erp",
        element: <ErpProductPage />,
      },
      {
        path: "product-adjustment",
        element: <ProductAdjustmentPage />,
      },
      {
        path: "replenishments",
        element: <ReplenishmentsPage />,
      },
      {
        path: "applicants",
        element: <ApplicantsPage />,
      },
      {
        path: "product-alias",
        element: <AliasProductPage />,
      },
      {
        path: "kits",
        element: <ProductKitPage />,
      },
      {
        path: "work-orders",
        element: <WorkOrdersPage />,
      },
      {
        path: "erp-code-client",
        element: null,
      },
      {
        path: "report-epp",
        element: <ReportEPPPage />,
      },
      {
        path: "report-general",
        element: <ReportGeneralPage />,
      },
      {
        path: "report-general",
        element: <ReportGeneralPage />,
      },
      {
        path: "client-entities",
        element: <ClientEntitiesPage />,
      },
      {
        path: "activity-labels",
        element: <ActivityLabelsPage />,
      },
      {
        path: "custom-report",
        element: <CustomReportPage />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);
